import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ec211da&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2ec211da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec211da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec211da')) {
      api.createRecord('2ec211da', component.options)
    } else {
      api.reload('2ec211da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ec211da&scoped=true&", function () {
      api.rerender('2ec211da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/campaignInfo/index.vue"
export default component.exports